/* eslint-disable jira/filename-case */

import { envType } from '@atlassiansox/analytics-web-client/analytics-web-types';
import type { Environment } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import { shouldBeChoreographed as shouldBeChoreographedFromFactory } from './main.tsx';
import type { ChoreographedMessage, MaybeChoreographedComponentProps } from './types.tsx';

export function shouldBeChoreographed(
	props?: Partial<MaybeChoreographedComponentProps>,
): props is ChoreographedMessage {
	return shouldBeChoreographedFromFactory(props);
}

export function environmentToEnvType(environment: Environment): envType {
	switch (environment) {
		case 'dev':
			return envType.DEV;
		case 'staging':
			return envType.STAGING;
		case 'prod':
			return envType.PROD;
		default:
			return envType.LOCAL;
	}
}
